import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Trans, translate } from 'react-i18next';
import { compose } from 'recompose';
import axios from 'axios';
import PreBook from './PreBook.js';
import * as $ from 'jquery';
import moment from 'moment-timezone';
import { Redirect } from 'react-router-dom';

let cancelToken;
let state;
let tokenSession;

class RoomStore extends Component {

    getInitState = () => {
        return {
            sala: null,
            book: null,
            GoToPay: false,
        }
    }

    constructor(props) {
        super(props);
        if (tokenSession !== props.getTokenSession()) {
            state = this.getInitState();
        }
        this.state = state;
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
    }

    componentDidMount() {
        this.reload();
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
        state = this.state;
        tokenSession = this.props.getTokenSession();
    }

    reload = () => {
        if (this.props.match.params.reservationsid) {
            this.getBooK({
                token_id: this.props.getTokenId(),
                token_session: this.props.getTokenSession(),
                reservation_id: this.props.match.params.reservationsid,
            });
        }


        this.getRoom({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
            room_id: this.props.match.params.roomid,
            ingles: false,
        });
    }

    getRoom = (params) => {
        this.props.post_store(
            "/getRoom",
            params,
            (response) => this.didGetSalas(response),
            (error) => this.props.handleErrorResponse(error),
            cancelToken
        );
    }

    getBooK = (params) => {
        this.props.post_store(
            "/getBook",
            params,
            (response) => this.didGetBook(response),
            (error) => this.props.handleErrorResponse(error),
            cancelToken
        );
    }

    didGetSalas = (response) => {
        this.setState({ sala: response })
    }

    didGetBook = (response) => {
        this.setState({ book: response })
    }

    handleErrorResponse = (error) => {
        alert(error)
    }

    handleConfirmarReservacion = () => {
        $('#btnSuccess').click()
    }

    renderRoomResevation = (props) => {
        return (
            <PreBook
                reservation={this.state.book}
                handleGoToPay={this.handleGoToPay}
            />
        )
    }

    renderSalasContainer = () => {
        const room = this.state.sala;
        const duration = this.state.duration
        const reservation = this.state.book
        let endDate = null;
        let startDate = null;
        if (this.state.book) {
            endDate = moment(reservation.fecha_final, 'YYYY-MM-DD HH:mm:ss');
            startDate = moment(reservation.fecha_inicial, 'YYYY-MM-DD HH:mm:ss');
        }
        const { t } = this.props;
        return (
            <div className="container-room">
                <div className="container-room-header card-panel panel panel-default card">
                    <div className="panel-heading card-panel-heading" style={{ backgroundImage: "url('" + room.imagen + "')" }}>
                    </div>
                    <div className="card-panel-body">
                        <div className="panel-body-title">
                            <h4 className="ioscentro">{room.name.toUpperCase()}</h4>
                        </div>
                        <div className="panel-body-description">
                            <div className="panel-description-text">
                                {room.descripcion.slice(0, 150)}{room.descripcion.length > 150 ? '...' : null}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-8 col-lg-8 col-md-4 col-sm-8 col-8" style={{ margin: '15px', textAlign: "left" }}>
                                <div className="contenedor-flexbox">
                                    <div className="contenedor">
                                        <i className="fa fa-users" aria-hidden="true">
                                        </i>
                                        Capacidad para {room.capacidad} personas.
                                    </div>
                                </div>
                                <div className="contenedor-flexbox">
                                    {duration ? (
                                        <div className="contenedor">
                                            <i className="fa fa-usd" aria-hidden="true"></i>
                                            {duration === '4' ? (
                                                " Precio de Sala por 2 Horas $" + room.hrs_2
                                            ) : (
                                                duration === '8' ? (
                                                    " Precio de Sala por 4 Horas $" + room.hrs_4
                                                ) : (
                                                    " Precio de Sala por un dia Completo $" + room.full_day
                                                )
                                            )}
                                        </div>
                                    ) : (
                                        <div className="contenedor">
                                            <i className="fa fa-usd" aria-hidden="true"></i>
                                            {" Precio de Sala por 2 Horas $" + room.hrs_2}
                                            <br></br>
                                            <i className="fa fa-usd" aria-hidden="true"></i>
                                            {" Precio de Sala por 4 Horas $" + room.hrs_4}
                                            <br></br>
                                            <i className="fa fa-usd" aria-hidden="true"></i>
                                            {" Precio de Sala por un dia Completo $" + room.full_day}
                                        </div>
                                    )}
                                </div>
                                <div className="contenedor-flexbox">
                                    <div className="contenedor">
                                        TIPO DE SALA  {room.tipo_sala}
                                    </div>
                                </div>
                            </div>
                            {this.state.book ? (
                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3" style={{ margin: '15px', textAlign: "left" }}>
                                    <div className="modal-body" style={{ color: '#FFFFF' }}>
                                        <div className="contenedor">
                                            <i className="fa fa-calendar" aria-hidden="true"></i>
                                            &ensp;
                                            {reservation ? startDate.format('ll') : null}
                                        </div>
                                        <div className="contenedor">
                                            <i className="fa fa-clock-o" aria-hidden="true"></i>
                                            &ensp;

                                            {startDate.format('HH:mm')} - {endDate.format('HH:mm')}
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        <div className="panel-body-bottom">
                            <div className="panel-body form-group">
                                <button
                                    className="btn btn-block btn-primary  btn-singup btn_create"
                                    onClick={() => this.setState({ GoToPay: true })}
                                    type="button">
                                    {t('dashboard.reservations.btn_pay')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-room-description">
                    <h4 className="page-header text-primary">
                        <strong>{t('dashboard.reservations.heading_services')}</strong>
                    </h4>
                    <div className="row">
                        <div className="col-md-6">
                            <p>
                                <strong>{t('dashboard.reservations.heading_included')}</strong>
                            </p>
                            <ul>
                                {room.servicios_incluidos.map((service, index) =>
                                    <li key={index}>{service.name}</li>
                                )}
                            </ul>
                        </div>
                        <div className="col-md-6">
                            <p>
                                <strong>{t('dashboard.reservations.heading_extras')}</strong>
                            </p>
                            <ul>
                                {room.servicios_adicionales.map((service, index) =>
                                    <li key={index}>{service.name}</li>
                                )}
                            </ul>
                        </div>
                    </div>

                </div>
                <div className="container-direction mapa">
                    <h4 className="page-header text-primary">
                    </h4>
                    <div className="iframe-wrapper">
                        {/* <iframe
                            frameBorder="0"
                            src={
                                "https://www.google.com/maps/d/embed?mid=1Cd02Lz4Q-XK73pQs9iA5jMJk86k&ll="
                                + center.latitude
                                + "%2C"
                                + center.longitude
                            }
                            title={t('dashboard.reservations.frame_center')}>
                        </iframe> */}
                    </div>
                </div>
            </div>
        )
    }

    render() {
        if (this.state.book) {
            const reservationId = this.state.book.id
            if (this.state.GoToPay) {
                return <Redirect push to={{
                    pathname: "/store_invitado" + "/book/" + reservationId
                }} />;
            }
        }
        const { t } = this.props;
        return (
            <div className="content-resvations">
                <div className="container-resvations-title">
                    <div className="row">
                        <h2 className="page-header">{t('dashboard.reservations.heading')}</h2>
                    </div>
                </div>
                {this.state.sala ? (
                    this.renderSalasContainer()
                ) : null}
            </div>
        )
    }
}

export default compose(
    translate('common'),
    withRouter
)(RoomStore);


// WEBPACK FOOTER //
// ./src/dashboard/store/Reservation/Room.js